// extracted by mini-css-extract-plugin
export default {"navIcon":"lmGAtz9O"};